module.exports = __webpack_public_path__ + "img/fun-tit.dbc44423.png";